import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilService, VariablesService, VwoService } from 'src/app/shared/services';
import { MatRippleModule } from '@angular/material/core';
import { CurrencyComponent } from '../currency/currency.component';
import { Insurance_Amount } from 'src/app/shared/models/insurance.model';

@Component({
  selector: 'app-insure-select',
  standalone: true,
  imports: [CommonModule, MatRippleModule, CurrencyComponent],
  templateUrl: './insure-select.component.html',
  styleUrls: ['./insure-select.component.scss']
})
export class InsureSelectComponent implements OnInit, OnChanges {

  @Input() insureData?: any;
  @Input() currency?: string;
  @Output() updateFamilyInsurance = new EventEmitter();

  viewMore = false;

  incremetalAmounts = Insurance_Amount;
  selectedAmount = 0;
  maxAmt = 0;
  progPerc = 0;

  desc = [
    { text: 'The critical illness insurance Daily  will cover for' },
    { text: 'major critical illness like,  cancer, dialysis and' },
    { text: 'other major illnesses with proof of medical disease' }
  ];

  constructor(
    public vars: VariablesService,
    private util: UtilService,
    private vwo: VwoService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.currency?.currentValue) {
      this.maxAmt = this.incremetalAmounts[this.currency].max;
      this.progPerc = this.util.getPercentage(this.insureData?.amount_requested, this.insureData?.raised);
      if(this.vwo.insurance_optin_amount_AB() && !this.vars.selectedFamilyInsurance){
        this.selectedAmount = 0;
      } else {
        this.selectedAmount = (this.incremetalAmounts[this.currency]?.min || 0) * 4;
        this.updateAmount('plus');
      }
    }
  }

  updateAmount(value: 'plus' | 'minus') {
    if (value === 'plus' && this.selectedAmount < this.maxAmt) {
      this.selectedAmount += this.incremetalAmounts[this.currency].increment;
    } else if (value === 'minus' && this.selectedAmount > 0) {
      this.selectedAmount -= this.incremetalAmounts[this.currency].increment;
    }
    this.setSelected();
  }

  setSelected() {
    if (!this.selectedAmount) {
      this.vars.selectedFamilyInsurance = null;
    } else {
      this.vars.selectedFamilyInsurance = {
        [this.insureData?.id]: { amount: this.selectedAmount }
      };
    }
    this.updateFamilyInsurance.emit(this.vars.selectedFamilyInsurance);
  }
}
